module.exports = __webpack_public_path__ + "img/ic_gongchengshi.df7fe45f.svg";